// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C3FnT","toggle":"styles_toggle___qzYq","preview":"styles_preview__2IhO4"};